export default __webpack_public_path__ + "static/media/culture_EP2.092e3fcb.png";